export enum ContactSource {
  AgencyCreated = "agency_created",
  GailCreated = "gail_created",
}

export enum PhoneType {
  Mobile = "mobile",
  Home = "home",
  Work = "work",
  Fax = "fax",
}
